import {
  CONFIG_STORAGE_BASE_URL,
  DEFAULT_WORKSPACE_PUBLIC_CONFIG,
  SCRIPT_WORKSPACE_ID_PARAM,
  CONFIG_ENABLED,
} from '../settings';
import { WorkspacePublicConfig } from '../types';
import fetchWithTimeout from '../utils/fetchWithTimeout';
import getUrlParam from '../utils/getUrlParam';

class Configuration {
  workspaceId: string;

  workspaceConfigURL: string;

  workspaceConfig: WorkspacePublicConfig = DEFAULT_WORKSPACE_PUBLIC_CONFIG;

  workspaceConfigLoadingStatus: 'pending' | 'success' | 'error' = 'pending';

  constructor(workspaceId: string) {
    this.workspaceId = workspaceId;
    this.workspaceConfigURL = `${CONFIG_STORAGE_BASE_URL}%2Fconfigs%2F${workspaceId}.json?alt=media`;
    this.fetchConfiguration();
  }

  async fetchConfiguration() {
    try {
      let workspacePublicConfig = {};

      if (CONFIG_ENABLED) {
        workspacePublicConfig = await fetchWithTimeout(this.workspaceConfigURL)
          .then((response) => response.json());
      }

      this.workspaceConfig = {
        ...workspacePublicConfig,
        ...DEFAULT_WORKSPACE_PUBLIC_CONFIG,
      };

      this.workspaceConfigLoadingStatus = 'success';
    } catch (error) {
      this.workspaceConfigLoadingStatus = 'error';
    }
  }

  getWorkspaceId() {
    return this.workspaceId;
  }

  async getWorkspaceConfig() {
    if (this.workspaceConfigLoadingStatus === 'pending') {
      await this.fetchConfiguration();
    }
    if (this.workspaceConfigLoadingStatus === 'error') {
      throw new Error('Workspace config is not found');
    }
    return this.workspaceConfig;
  }

  static create(scriptSelector: string) {
    const script = document.querySelector(scriptSelector) as HTMLScriptElement;
    const workspaceId = getUrlParam(script.src, SCRIPT_WORKSPACE_ID_PARAM);
    if (!workspaceId) {
      throw new Error('Workspace ID is not found');
    }
    return new Configuration(workspaceId);
  }
}

export default Configuration;
